<div class="container">
  <div class="row">
    <div class="col-1"></div>
    <div class="col">
      <mat-card class="mat-elevation-z0">
        <h1 class="h1 text-center">Contact Us</h1>
        <form aria-autocomplete="none" [formGroup]="formContactus">
          <!--<hr />-->
          <div  class="mb-4">
            <div class="input-group row">
              <div class="input-group-prepend col-4">
                <span>Name</span>
              </div>
              <input type="text" class="form-control col-8" formControlName="name" />
            </div>
            <div class="row" *ngIf="formContactus.controls['name'].invalid && (formContactus.controls['name'].dirty || formContactus.controls['name'].touched)">
              <div class="col-4"></div>
              <div *ngIf="formContactus.controls['name'].errors.required" class="col text-danger">
                *required
              </div>
            </div>
          </div>
          <!--<hr />-->

          <div class="mb-4">
            <div class="input-group row">
              <div class="input-group-prepend col-4">
                <span>Company Name</span>
              </div>
              <input type="text" class="form-control col-8" formControlName="companyName" />
            </div>
            <div class="row" *ngIf="formContactus.controls['companyName'].invalid && (formContactus.controls['companyName'].dirty || formContactus.controls['companyName'].touched)">
              <div class="col-4"></div>
              <div *ngIf="formContactus.controls['companyName'].errors.required" class="col text-danger">
                *required
              </div>
            </div>
          </div>
          <!--<hr />-->

          <div class="mb-4">
            <div class="input-group row">
              <div class="input-group-prepend col-4">
                <span>
                  Email
                </span>
              </div>
              <input type="text" rows="4" class="form-control col-8" formControlName="companyEmail" />
            </div>
            <div class="row" *ngIf="formContactus.controls['companyEmail'].invalid && (formContactus.controls['companyEmail'].dirty || formContactus.controls['companyEmail'].touched)">
              <div class="col-4"></div>
              <div *ngIf="formContactus.controls['companyEmail'].errors.required" class="col text-danger">
                *required
              </div>
              <div *ngIf="formContactus.controls['companyEmail'].errors.email" class="col text-danger">
                *valid email address expected
              </div>
            </div>
          </div>
          <!--<hr />-->
          <div class="mb-4">
            <div class="input-group row">
              <div class="input-group-prepend col-4">
                <span>
                  Phone Number
                </span>
              </div>
              <input type="text" rows="4" class="form-control col-8" formControlName="phoneContactPerson" />
            </div>
            <div class="row" *ngIf="formContactus.controls['phoneContactPerson'].invalid && (formContactus.controls['phoneContactPerson'].dirty || formContactus.controls['phoneContactPerson'].touched)">
              <div class="col-4"></div>
              <div *ngIf="formContactus.controls['phoneContactPerson'].errors.required" class="col text-danger">
                *required
              </div>
            </div>
          </div>
          <!--<hr />-->
          <div class="mb-4">
            <div class="input-group row">
              <div class="input-group-prepend col-4">
                <span>
                  Comments
                </span>
              </div>
              <textarea type="text" rows="4" class="form-control col-8" formControlName="comments"></textarea>
            </div>
            <div class="row" *ngIf="formContactus.controls['comments'].invalid && (formContactus.controls['comments'].dirty || formContactus.controls['comments'].touched)">
              <div class="col-4"></div>
              <div *ngIf="formContactus.controls['comments'].errors.required" class="col text-danger">
                *required
              </div>
            </div>
          </div>
          <!--<hr />-->
          <div>
            <button mat-raised-button color="primary" type="button" class="btn" (click)="submitContactUs()" style="margin-left:5px">Submit</button>

          </div>
        </form>
      </mat-card>
    </div>
    <div class="col-1"></div>
  </div>
</div>
